import * as types from "../../actions/types";


export default function googleMapsReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_COORDINATES:
      return action;

    case types.RESET_MAP:
      return action;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/GoogleMaps/googleMapsReducer.js